import { Box, HStack } from '@bpba/ui-components';
import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router';
import { ReactComponent as SearchLogo } from '../../assets/icons/search.svg';
import styled from 'styled-components';
import { LayoutProps, layout, SpaceProps, space, DisplayProps } from 'styled-system';
import { RESULTADO_PATH } from '../catalogo/Resultado';
import { StyledInput } from '../shared/form/StyledInput';

const KEYBOARD_ENTER = 'Enter';

type Props = {
  color: string;
};

export const Buscador: FC<Props> = ({ color }) => {
  const [searchText, setSearchText] = useState<string>('');
  const navigate = useNavigate();

  function search() {
    if (!searchText) return;

    const trimmedSearchText = searchText.trim();
    if (trimmedSearchText.length === 0) return;

    const encodedSearchText = encodeURIComponent(trimmedSearchText);
    const url = `${RESULTADO_PATH}?b=${encodedSearchText}`;
    navigate(url, { replace: true });
  }

  function onKeyDown(event: React.KeyboardEvent) {
    if (event.key === KEYBOARD_ENTER) search();
  }

  return (
    <HStack
      height={['35px', '40px']}
      borderRadius={'3px'}
      background={color}
      width={['100%', null, 'fit-content']}
      onKeyDown={onKeyDown}
      marginLeft={['16px', null, '8px']}
      marginRight={['16px', null, '8px']}
    >
      <Box width={['100%', null, 280, null, 350]} alignItems="center">
        {/* Mobile */}
        <SearchInput display={['unset', 'none']} placeholder="Buscar..." value={searchText} setValue={setSearchText} />
        {/* Otras pantallas */}
        <SearchInput display={['none', 'unset']} placeholder="Encontrá lo que buscas" value={searchText} setValue={setSearchText} />
      </Box>
      <StyledSearchLogo width={24} margin="auto 8px" fill={'secondary.1'} onClick={search} />
    </HStack>
  );
};

type SearchInputProps = {
  placeholder: string;
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
} & DisplayProps;

const SearchInput: FC<SearchInputProps> = ({ placeholder, value, setValue, ...otherProps }) => {
  return (
    <StyledInput
      placeholder={placeholder}
      fontSize="inherit"
      border="none"
      backgroundColor="transparent"
      height="100%"
      mr="0px"
      marginBottom={0}
      paddingY={0}
      borderRadius={'4px!important'}
      paddingX={[12]}
      value={value}
      onChange={(event) => setValue(event?.target?.value)}
      {...otherProps}
    />
  );
};

type StyledSearchLogoProps = {
  fill?: string;
} & LayoutProps &
  SpaceProps;

const StyledSearchLogo = styled(SearchLogo)<StyledSearchLogoProps>(layout, space, (props) => ({
  fill: props.fill,
  cursor: 'pointer',
}));
